import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { PlayButtonCompat } from '../components/compat/play-button-compat';
import { Loading } from '../components/loading/loading';
import { ContainerQuery } from 'react-container-query';
import { AccountInvitesCompat } from '../components/compat/account-invites-compat';
import { BrandSponsoredLabelCompat } from '../components/compat/brand-sponsored-label-compat';
import {PageCheckoutHeader} from '../components/page-checkout-header';
import {PageCheckoutPanels} from '../components/page-checkout-panels';
import {PageCheckoutContentStep1} from '../components/page-checkout-content-step-1';
import {PageCheckoutContentStep2} from '../components/page-checkout-content-step-2';
import {PageCheckoutContentStep3} from '../components/page-checkout-content-step-3';
import {PageCheckoutContentStep0} from '../components/page-checkout-content-step-0';
import {PageCheckoutPanelStep0} from '../components/page-checkout-panel-step-0';
import {PageCheckoutPanelStep2} from '../components/page-checkout-panel-step-2';
import {noop} from '../lib/noop';
import MainWrapper from '../components/main-wrapper';
import {style} from 'typestyle';
import {centerCenter, vertical} from 'csstips';
import {rem} from 'csx';
import LabelModal from "../components/label-modal";

export interface CheckoutContainerProps {

}

@inject(deps) @observer
export class CheckoutContainer extends Component<CheckoutContainerProps> {

  constructor(props) {
    super(props);

    this.state = {
      labelCopyrightModalAccepted: false,
      showModal: false,
      continueOrder: false
    }
  }

  render() {
    const { model, controller } = this.props;

    if (model.user.loading || model.coupon.loading) return (
      <div className={CheckoutContainer.styles.loading}>
        <Loading />
      </div>
    );

    // Dereference to enable reactivity
    const { step, channel } = model.checkout;

    const ratecard = model.user && model.user.channel && model.user.channel.ratecard;
    return (
      <ContainerQuery query={CheckoutContainer.query} children={(params: any = CheckoutContainer.defaultQuery) => (
        <MainWrapper>
          <PageCheckoutHeader
            model={model.checkout}
            onSelectStep={noop}
          />
          <PageCheckoutPanels
            model={model.checkout}
            narrow={params.narrow}
            PlayButton={PlayButtonCompat}
            onContinue={!channel ? controller.onboarding.openSignUpModal : this.handleContinue}
            onCancel={controller.checkout.cancelOrder}
            left={this.getStep(step)}
            right={this.getPanel(step)}
          />
          {model.checkout.hasUmgContent && (
              <LabelModal
                  show={this.state.showModal}
                  tracks={model.checkout.tracks}
                  onRequestClose={this.handleModalClose}
                  handleModalAccept={this.handleModalAccept}
                  ratecard={ratecard}
              />
          )}
        </MainWrapper>
      )}/>
    )
  }

  getStep = (step: number) => {
    const { checkout } = this.props.model;
    const { selectCard, addCard, removeTrack, selectAddress, changeCardForm, changeVatNumber } = this.props.controller.checkout;
    const { showDownloadModal, showAttributionModal } = this.props.controller.modal;
    const { preloadCover, preloadWaveformSvg } = this.props.controller.image;
    const { handleClickLink } = this.props.controller.ui;

    switch (step) {
      case 1: return (
        <PageCheckoutContentStep1
          model={checkout}
          onAddCard={addCard}
          onSelectCard={selectCard}
          onSelectAddress={selectAddress}
          onChangeVatNumber={changeVatNumber}
          onChangeCardForm={changeCardForm}
        />
      );

      case 2: return (
        <PageCheckoutContentStep2
          model={checkout}
          PlayButton={PlayButtonCompat}
          BrandSponsoredLabel={BrandSponsoredLabelCompat}
          preload={preloadCover}
          preloadWaveform={preloadWaveformSvg}
          onClickLink={handleClickLink}
        />
      );

      case 3: return (
        <PageCheckoutContentStep3
          model={checkout}
          PlayButton={PlayButtonCompat}
          Share={AccountInvitesCompat}
          BrandSponsoredLabel={BrandSponsoredLabelCompat}
          preload={preloadCover}
          preloadWaveform={preloadWaveformSvg}
          onDownload={showDownloadModal}
          onAttribution={showAttributionModal}
          onClickLink={handleClickLink}
        />
      );

      default: return (
        <PageCheckoutContentStep0
          model={checkout}
          PlayButton={PlayButtonCompat}
          BrandSponsoredLabel={BrandSponsoredLabelCompat}
          onRemoveTrack={removeTrack}
          preload={preloadCover}
          preloadWaveform={preloadWaveformSvg}
          onClickLink={handleClickLink}
          onLabelCopyrightClick={this.handleLabelCopyrightClick}
        />
      );
    }
  };

  getPanel = (step: number) => {
    const { checkout } = this.props.model;
    const { changeCouponCode } = this.props.controller.checkout;

    if (!checkout.channel) return (
      <div className={CheckoutContainer.styles.panel}>
        <h5>Please register / sign in to checkout</h5>
      </div>
    );

    switch (step) {
      case 0: return (
        <PageCheckoutPanelStep0
          model={checkout}
          onSelectChannel={this.props.controller.modal.showChannelSelectModal}
          onChangeCouponCode={changeCouponCode}
        />
      );

      case 1:
      case 2: return (
        <PageCheckoutPanelStep2
          model={checkout}
        />
      );

      default: return null;
    }
  };

  handleLabelCopyrightClick = () => {
    this.setState({
      showModal: true
    });
  };

  handleModalClose = () => {
    this.setState({showModal: false});
  };

  handleModalAccept = () => {
    this.setState({
      showModal: false,
      labelCopyrightModalAccepted: true
    });

    if (this.state.continueOrder) {
      this.props.controller.checkout.continueOrder();
    }
  };

  handleContinue = () => {
    const {model} = this.props;

    if (model.checkout.hasUmgContent && !this.state.labelCopyrightModalAccepted) {
      this.setState({
        showModal:true,
      });
      return;
    }

    this.props.controller.checkout.continueOrder();
  };

  static query = {
    narrow: {
      maxWidth: 960
    }
  };

  static defaultQuery = {
    narrow: false
  };

  static styles = {
    loading: style({
      ...centerCenter,
      minHeight: rem(32)
    }),
    panel: style({
      ...vertical,
      flex: 1,
      $nest: {
        '& h5': {
          margin: '0 0 1rem 0'
        }
      }
    }),
  }
}